<script>
  // drop files for upload
  import { createEventDispatcher } from 'svelte'
  export let style = "border:1px dashed #ccc;height:100%;width:100%;"
  export let types
  let files = []

  const dispatch = createEventDispatcher();

  const handleDrop = (e)=>{
    e.preventDefault()
    if(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length){
      files = filterTypes(e.dataTransfer.files)
    }
    dispatch('updated', {files});
  }

  const filterTypes = (droppedfiles)=>{
    if(!types || !types.length){
      return droppedfiles
    }
    return Array.from(droppedfiles).filter( f =>{ 
      if(types.includes(f.type)){
        return true
      }else{
        console.warn("can't drop",f.type)
      }
    })
  }

  const handleDragOver = (e)=>{
    e.preventDefault()
  }


</script>
<div {style} on:drop={handleDrop} on:dragover={handleDragOver}>
  <slot {files}></slot>
</div>
